// extracted by mini-css-extract-plugin
export default {"heading":"heading§yMsFmbzE7BmDbQp1GhhH","text":"text§X_VfcTtfJxk2B_36O7fO","actions":"actions§oy5g_uf6k57s2ShAAefA"};